// extracted by mini-css-extract-plugin
export var container = "_4v-0";
export var infoButton = "_4v-1";
export var label = "_4v-3";
export var labelExpanded = "_4v-4";
export var price = "_4v-5";
export var priceExpanded = "_4v-6";
export var title = "_4v-2";